/** 服务类别管理API */
import type { Api } from '@/typings/api';
import { download, post, upload } from '../../request';
const prefix = '/store/serviceType';
/**
 * 分页查询服务类别管理
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Store.ServiceType> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询服务类别管理列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Store.ServiceType> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个服务类别管理
 *
 * @param id 服务类别管理ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Store.ServiceType> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存服务类别管理
 *
 * @param params 服务类别管理信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新服务类别管理信息
 *
 * @param params 服务类别管理信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除服务类别管理
 *
 * @param id 服务类别管理ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除服务类别管理
 *
 * @param ids 服务类别管理ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/**
 * 导出
 *
 * @param params
 * @returns
 */
export const doExport = (params: Api.Common.CommonSearchParams) => {
  return download(`${prefix}/export`, params);
};

/**
 * 导入
 *
 * @param file 文件
 * @param params
 * @returns
 */
export const doImport = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/import`, file, params);
};

/**
 * 增量同步服务类别和服务项目模板
 *
 * @returns
 */
export const syncServiceTypeAndItem = (customerId: string | undefined) => {
  return post(`${prefix}/syncServiceTypeAndItem?customerId=${customerId}`);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  syncServiceTypeAndItem
};
